import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Action, RequestMiddleware } from '@forgerock/javascript-sdk/dist/config/interfaces';
import { HcscTou } from '../../shared/services/forge-rock.interface';
import { ForgeRockService } from '../../shared/services/forge-rock.service';
import { UserService } from '../../shared/services/user.service';
import { AbstractJourneyComponent } from '../abstract-journey/abstract-journey.component';


export function hcscTouHeader(tou:{}): RequestMiddleware {
  return (req:any,action:Action,next) => {
      let _tou = JSON.stringify(tou);
      const headers = req.init.headers as Headers;
      headers.append('hcsc-tou',`{"termsOfService": ${_tou} }`);
      next();
  }
}
@Component({
    selector: 'journey-update-tou',
    templateUrl: './journey-update-tou.component.html',
    providers: [DatePipe]
})
export class JourneyUpdateTouComponent extends AbstractJourneyComponent implements OnInit {

  translationData:any = {}  
  showSpinner = false;
  hasValidTou = false;
  @Output() onTouUpdated = new EventEmitter<any>();
  
  constructor(
    protected override router: Router, 
    protected override route:ActivatedRoute,
    protected override FRService: ForgeRockService,
    protected override userService: UserService,
    private datePipe: DatePipe
)  {
    super(FRService,router,route,userService);
  }

  override getTreeName(): string {
    return 'updateTOU';
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.showSpinner = true;
    this.shouldContinueWithUpdate().then((isUpdate) => {
      if (isUpdate) {
        this.showSpinner = false;
      }else{
        this.hasValidTou = true;
        this.onStepComplete(true);
      }
    });
  }

  override ngAfterViewInit():void {
  }


  onStepComplete(data:any) {
    if (data === true) {
        if (!this.hasValidTou) {
          this.addTocHeader();
           this.beginUpdateTouJourney();
        }  
        this.onTouUpdated.emit({status: 'SUCCESS', loginRedirect: this.loginRedirect});
        this.goHome();
    }else{
      this.onTouUpdated.emit({status: 'FAILURE', loginRedirect: this.loginRedirect});
    }
  }

  private addTocHeader() {
      if (this.tou) {
        let tou = {} as HcscTou;
        tou.hcscAppID = this.tou.appname;
        tou.corpCode = this.tou.corpcode;
        tou.version = this.tou.version;
        tou.acceptedDate = this.datePipe.transform(new Date(),'MM-dd-yyyy');
        this.middleware = [hcscTouHeader(tou)];
      } 
  }

  private async shouldContinueWithUpdate() {
    if (!(this.tou && this.tou.appname && this.tou.version && this.tou.corpcode)) {
      return Promise.resolve(false);
    }
    const data = await this.getUserInfo();
    if (data) {
      let user = data as {};
      let tous: string[] = user['tou' as keyof {}];
      const ndx = tous.map((tou) => JSON.parse(tou)).findIndex((oTou) => {
        return oTou.appName === this.tou?.appname && oTou.corpCode === this.tou?.corpcode && oTou.version === this.tou?.version;
      });
      return ndx < 0;
    }
    throw new Error("Could not find a valid login");
  }
}
